import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Inject FAQ or other JSON-LD blocks for a route.
 */
export default function JsonLd({ data }) {
  if (!data) return null;

  const blocks = Array.isArray(data) ? data : [data];

  return (
    <Helmet>
      {blocks.map((block) => (
        <script key={JSON.stringify(block['@type'] || block)} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}

export function buildFaqSchema(faqs) {
  if (!faqs?.length) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}
